import { booking, totalusers } from '@assets/icons'
import { Fragment } from 'react/jsx-runtime'
import Column from '@components/column'
import Title from '@components/title'
import DashboardCard from '@commons/cards/dashboard'
import Users from '@commons/users'
import UserProfile from '@components/userprofile'
import {
  DateText,
  DateTimeContainer,
  TimeText,
} from '@pages/admin/user-management/users/style'
import { Helper } from '@utils'

const cardConfig = [
  {
    key: 'totalUsers',
    title: 'Total Users',
    icon: totalusers,
    isUp: true,
    link: '/admin/user-management/users',
  },
  {
    key: 'totalBookings',
    title: 'Total Bookings',
    icon: booking,
    isUp: true,
    link: '/admin/bookings',
  },
  {
    key: 'totalActiveBooking',
    title: 'Active Bookings',
    icon: booking,
    isUp: false,
    link: '/admin/bookings?tab=Active%20Bookings',
  },
  {
    key: 'totalCompletedBooking',
    title: 'Completed Bookings',
    icon: booking,
    isUp: false,
    link: '/admin/bookings?tab=Completed%20Bookings',
  },
]

const UserManagement = () => {
  const columns: any = [
    {
      title: 'S.N',
      key: 'sn',
      render: (_item, index) => index,
    },
    {
      title: 'User Detail',
      key: 'userDetail',
      render: (item) => <UserProfile item={item} />,
    },
    {
      title: 'Email',
      key: 'email',
      render: (item) => item.email || 'N/A',
    },
    {
      title: 'Mobile Number',
      key: 'mobileNumber',
      render: (item) => item.phoneNo || 'N/A',
    },
    {
      title: 'Created On',
      key: 'createdOn',
      render: (item) => (
        <DateTimeContainer>
          <DateText>{Helper.formatDate(item.createdAt)}</DateText>
          <TimeText>{Helper.formatTime(item.createdAt)}</TimeText>
        </DateTimeContainer>
      ),
    },
  ]
  return (
    <Fragment>
      <Column>
        <DashboardCard cardConfig={cardConfig} />
        <Title textone="User" texttwo="Management" />
        <Users
          title={'User List'}
          icon={totalusers}
          columns={columns}
          role="user"
        />
      </Column>
    </Fragment>
  )
}
export default UserManagement
